import React from 'react';
import { NewsContainerDisplay } from 'components/styles/News.styled';
import { translate as t } from 'utils/i18n';
import BaseNewsDisplay from './BaseNewsDisplay';

class NewsDisplay extends BaseNewsDisplay {
  render() {
    const { feedItems, loading } = this.state;
    const description = this.props.news['locale_latest_news']?.locale_description;

    if (loading) {
      return (
        <NewsContainerDisplay
          style={{ height: this.props.height, background: this.props.background }}
          ref={this.scrollRef}
          className='loading'
        >
          <p style={{ color: this.props.color, background: this.props.background }}>
            {t('errors.loadingMessage')}
          </p>
        </NewsContainerDisplay>
      );
    }

    if (feedItems.length > 0) {
      return (
        <NewsContainerDisplay
          style={{ height: this.props.height, background: this.props.background }}
          ref={this.scrollRef}
        >
          {feedItems.map((item, index) => (
            <div
              key={index}
              style={{
                marginBottom: '30px',
                padding: '15px',
                backgroundColor: this.props.background ?? '#f8f9fa',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
              }}
            >
              <h3
                style={{
                  fontSize: '1.3em',
                  fontWeight: 'bold',
                  marginBottom: '10px',
                  color: this.props.color ?? '#212529',
                }}
              >
                {item.title}
              </h3>
              <p
                style={{
                  lineHeight: '1.6',
                  marginBottom: '10px',
                  color: this.props.color ?? '#495057',
                }}
              >
                {item.description}
              </p>
              {item.pubDate && (
                <p
                  style={{
                    fontSize: '0.85em',
                    color: this.props.color ?? '#6c757d',
                    fontStyle: 'italic',
                    textAlign: 'right',
                  }}
                >
                  {new Date(item.pubDate).toLocaleString()}
                </p>
              )}
            </div>
          ))}
        </NewsContainerDisplay>
      );
    }

    if (description) {
      return (
        <NewsContainerDisplay
          style={{ height: this.props.height, background: this.props.background }}
          ref={this.scrollRef}
        >
          <div>
            <p style={{ color: this.props.color }}>{description}</p>
          </div>
        </NewsContainerDisplay>
      );
    }

    return (
      <NewsContainerDisplay
        style={{ height: this.props.height, background: this.props.background }}
        ref={this.scrollRef}
      >
        <p style={{ textAlign: 'center', padding: '20px', color: this.props.color }}>
          {'No news feed configured.'}
        </p>
      </NewsContainerDisplay>
    );
  }
}

export default NewsDisplay;
